export const allowlistAddresses = [


    ["0xa17cc03654e43576fd890c3aeeb3670fb70dd540",12],
    ["0x5c3d97f9a3b7938ca043b3a671b4b05291a94823",12],
    ["0xee7dee83fe3209db0035fcf60f1edd930ec2f8c0",12],
    ["0xa909427988bb1ea4924b522eddebb9b6fb29a2f1",12],
    ["0xdcea2a0baef09252c30ba97d7f309f5ca4c2af46",12],
    ["0x98ecede361efeea6c400fd6b3e590efabab39448",12],
    ["0xac75248edcd608878324c6894427977f8ef8599d",12],
    ["0xdd11a8a06c16fa9292c0fb80cc7964c12d467c3f",12],
    ["0x69e9ec83cba73744fa44f4183e200e038320f4dc",12],
    ["0x87369e67068197d9a164884c4541bd1503ccfb8f",12],
    ["0xdeb3f6f80e1f9fc698990171a48578ecd2e42aef",12],
    ["0x89fc135b9edd480d4945afb36f67b609e73e1b90",12],
    ["0xb7d994657d400d434e84b11d02c935be69957657",12],
    ["0x74433ede05e90b31d2c36cfd0be51921b438e500",12],
    ["0x6112b496e43a05e61797743a45640df13efcf053",12],
    ["0x826d434d6fb50a988a7823adc16db3fd11fa29e9",12],
    ["0x1a3326bf12589ee53b3f796c9d376ea3df60d459",12],
    ["0xfbc41168272707768a85706ea09feaa64680e712",12],
    ["0x82e1e9666edac4eb98850ce2ef2cf9bfedf2183d",12],
    ["0x21b5ad7ea02d44dd1e2ce38487da8781b84fd13a",12],
    ["0x48147b2c543a0eea58da03f54a9da3aa828b1584",12],
    ["0x03eeba1287dbbc6e5a10e3c916976a27ad00fe29",12],
    ["0x2bd8afa9bdfd2899326b833507bd4dd0bfd846df",12],
    ["0xdecf4b112d4120b6998e5020a6b4819e490f7db6",12],    

]